import React from 'react'
import { PropTypes } from 'prop-types'
import CTALink from '../CTALink'
import Column from '../Grids/Column'
import {
	CallOutContainer,
	CallOutDescription,
	CallOutTwoColumnGridContainer,
	CallOutThreeColumnGridContainer,
	CallOutFourColumnGridContainer,
	CallOutTitle,
	CallOutMainCTA,
	GridSection,
	CallOutOneColumnGridContainer,
} from './CallOut.styles'

export default function CallOut({ title, description, grid, center, gridContent, mainCTA, colorlist, bgImage }) {
	const theme = colorlist ? colorlist.title.toLowerCase() : ''
	const bgImg = colorlist ? undefined : bgImage

	return (
		<CallOutContainer colorlist={colorlist} bgImage={bgImg}>
			<GridSection className={theme}>
				{title ? <CallOutTitle>{title}</CallOutTitle> : null}
				{description ? <CallOutDescription>{description}</CallOutDescription> : null}
				{grid &&
					grid === 'oneColumn' &&
					(gridContent ? (
						<CallOutOneColumnGridContainer>
							{gridContent.map((column) => (
								<Column key={column._key} mW={768} center={center} {...column} />
							))}
						</CallOutOneColumnGridContainer>
					) : null)}
				{grid &&
					grid === 'twoColumn' &&
					(gridContent ? (
						<CallOutTwoColumnGridContainer center={center}>
							{gridContent.map((column) => (
								<Column key={column._key} mW={768} center={center} {...column} />
							))}
						</CallOutTwoColumnGridContainer>
					) : null)}
				{grid &&
					grid === 'threeColumn' &&
					(gridContent ? (
						<CallOutThreeColumnGridContainer center={center}>
							{gridContent.map((column) => (
								<Column key={column._key} mW={768} center={center} {...column} />
							))}
						</CallOutThreeColumnGridContainer>
					) : null)}
				{grid &&
					grid === 'fourColumn' &&
					(gridContent ? (
						<CallOutFourColumnGridContainer center={center}>
							{gridContent.map((column) => (
								<Column key={column._key} mW={768} center={center} {...column} />
							))}
						</CallOutFourColumnGridContainer>
					) : null)}
				{mainCTA ? (
					<CallOutMainCTA>
						<CTALink {...mainCTA} />
					</CallOutMainCTA>
				) : null}
			</GridSection>
		</CallOutContainer>
	)
}

CallOut.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	grid: PropTypes.string,
	center: PropTypes.bool,
	gridContent: PropTypes.array,
	mainCTA: PropTypes.object,
	colorlist: PropTypes.object,
	bgImage: PropTypes.object,
}
